import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { cn } from '../../lib/utils';
export function DashboardLayout({
  children
}: {
  children: React.ReactNode;
}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="min-h-screen bg-slate-50 flex" data-id="element-21">
      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} data-id="element-22" />}

      {/* Sidebar - Fixed */}
      <div className={cn('fixed inset-y-0 left-0 z-50 transform transition-transform duration-200 ease-in-out lg:translate-x-0', sidebarOpen ? 'translate-x-0' : '-translate-x-full')} data-id="element-23">
        <Sidebar data-id="element-24" />
      </div>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 lg:ml-64" data-id="element-25">
        {/* Header - Fixed */}
        <div className="fixed top-0 right-0 left-0 lg:left-64 z-30 bg-white border-b border-slate-200" data-id="element-26">
          <Header onMenuClick={() => setSidebarOpen(true)} data-id="element-27" />
        </div>

        {/* Scrollable Content */}
        <main className="flex-1 overflow-y-auto pt-24 px-4 pb-4 lg:px-8 lg:pb-8" data-id="element-28">
          <div className="max-w-7xl mx-auto" data-id="element-29">{children}</div>
        </main>
      </div>
    </div>;
}